import { render, staticRenderFns } from "./SmallStatCard.vue?vue&type=template&id=724ee985&scoped=true&"
import script from "./SmallStatCard.vue?vue&type=script&lang=js&"
export * from "./SmallStatCard.vue?vue&type=script&lang=js&"
import style0 from "./SmallStatCard.vue?vue&type=style&index=0&id=724ee985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724ee985",
  null
  
)

export default component.exports